module.exports = __webpack_public_path__ + "img/price-kayoi.7671ff6e.jpg";